
import { computed, defineComponent, inject } from '@nuxtjs/composition-api'
import BaseButton from '~/components/BaseButton.vue'

export default defineComponent({
  name: 'TabItem',
  components: {
    BaseButton
  },
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  setup (_, { attrs }) {
    const { tabMaxContentHeight, tabShowText, tabHideText, activeIndex, setActiveIndex } = inject('tabConfig')
    const index = computed(() => +attrs.index)
    const isActive = computed(() => index.value === activeIndex.value)

    function tabClick () {
      setActiveIndex(index.value)
    }

    return {
      isActive,
      tabMaxContentHeight,
      tabShowText,
      tabHideText,
      tabClick
    }
  }
})
